import { cn } from '@/lib/utils';

interface XIconProps {
    className?: string;
}

export function XIcon({ className }: XIconProps) {
    return (
        <svg
            viewBox='0 0 100 100'
            aria-hidden='true'
            className={cn('h-5 w-5 shrink-0', className)}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M77.4199 0H22.5801C10.1094 0 0 10.1563 0 22.6846V77.3154C0 89.8437 10.1094 100 22.5801 100H77.4199C89.8906 100 100 89.8437 100 77.3154V22.6846C100 10.1563 89.8906 0 77.4199 0Z'
                fill='black'
            />
            <path
                d='M63.2305 29.1088H70.2852L54.8731 46.8075L73.0039 70.8892H58.8066L47.6875 56.2848L34.9629 70.8892H27.9043L44.3887 51.9602L26.9961 29.1088H41.5527L51.6035 42.4594L63.2305 29.1088ZM60.7539 66.647H64.6641L39.4297 33.1292H35.2344L60.7539 66.647Z'
                fill='white'
            />
        </svg>
    );
}
